import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCustomerKey,
  ShopifyShopKey,
  ShopifyStoreCreditAccountKey,
  ShopifyStoreCreditAccountToCustomerKey,
  ShopifyStoreCreditAccountToShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { buildConnectionSpec, ConnectionModelSpecVersion } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyStoreCreditAccountKey,
  "2024-07": {
    name: "Shopify Store Credit Account",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Balance",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "balance",
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      //TODO
      // {
      //   name: "Transactions",
      //   fieldType: FieldType.HasMany,
      //   configuration: {
      //     dependent: "delete",
      //     relatedModelKey: ShopifyStoreCreditAccountTransactionKey,
      //     inverseFieldKey: ShopifyStoreCreditAccountTransactionToStoreCreditAccountKey,
      //   },
      // },
      {
        name: "Owner",
        fieldType: FieldType.BelongsTo,
        key: ShopifyStoreCreditAccountToCustomerKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "owner",
            graphQLSelection: `
              ... on Customer {
              id
            }
          `,
          },
        },
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyStoreCreditAccountToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "customer",
      resource: "customer.storeCreditAccounts",
    },
  },
};

export const ShopifyStoreCreditAccount = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
